:host {
  display: block;
  cursor: pointer;
}

::slotted(*) {
  font-size: 14px;
}

.playlist {
  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px;
    transition: background-color 0.25s ease;
    color: var(--presto-playlist-text-color, var(--plyr-audio-control-color, #4a5464));
    user-select: none;
    border-radius: 8px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    &.playlist__item-is--active {
      background-color: var(--presto-playlist-highlight-color, var(--plyr-color-main, #2e4cd9));
      padding: 6px;
      color: var(--playlist-highlight-text-color, #fff);
      border-radius: 8px;
      .playlist__title-wrap > div {
        background-color: var(--playlist-highlight-text-color, #fff);
      }
      svg {
        fill: var(--presto-playlist-highlight-color, var(--plyr-color-main, #2e4cd9));
      }
    }

    svg {
      fill: currentColor;
    }

    .presto-icon-play path {
      transform: translateX(1px);
    }
  }

  &__title-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 14px;
  }

  &__play-icon {
    display: flex;
    padding: 2px;
    border-radius: 50%;
    background: rgba(180, 184, 199, 0.25);
  }

  &__time {
    opacity: 0.8;
    font-size: 12px;
    padding: 0 4px;
  }
}
